// Rascunho da compra nova no navegador: sair pelo menu não perde o que já foi lançado.
const chave = () => {
  let loja = "";
  try { loja = localStorage.getItem("__last_slug__") || ""; } catch { /* sem storage */ }
  return `nucleo:compra-rascunho:${loja}`;
};

export function lerRascunho() {
  try {
    const r = JSON.parse(localStorage.getItem(chave()) || "null");
    return r && Array.isArray(r.itens) ? r : null;
  } catch {
    return null;
  }
}

export function salvarRascunho(r) {
  try {
    if (!r.itens.length && !r.fornecedor) localStorage.removeItem(chave());
    else localStorage.setItem(chave(), JSON.stringify(r));
  } catch { /* sem storage */ }
}

export function apagarRascunho() {
  try { localStorage.removeItem(chave()); } catch { /* sem storage */ }
}
